import axios from 'axios';
import { getAccessToken } from '~/utils';

export const getSubmissionsByUserProblemId = async (user_id, problem_id) => {
    return axios
        .get(`${process.env.REACT_APP_LOCAL_API_URL}/submissions/${user_id}/${problem_id}`)
        .then((response) => response.data)
        .catch((error) => {
            console.log(error);
            return error.response;
        });
};

export const createSubmission = async (props) => {
    return axios
        .post(`${process.env.REACT_APP_LOCAL_API_URL}/submissions/create`, props)
        .then((response) => response.data)
        .catch((error) => {
            console.log(error);
            return error.response;
        });
};

export const getSubmissionsByTopicProblemId = async (topic_problem_id) => {
    return axios
        .get(`${process.env.REACT_APP_LOCAL_API_URL}/submissions/${topic_problem_id}/me`, {
            headers: getAccessToken(),
        })
        .then((response) => response.data)
        .catch((error) => {
            console.log(error);
            return error.response;
        });
};

export const getAllSubmissions = async (topic_problem_id) => {
    return axios
        .get(`${process.env.REACT_APP_LOCAL_API_URL}/submissions/${topic_problem_id}/all`, {
            headers: getAccessToken(),
        })
        .then((response) => response.data)
        .catch((error) => {
            console.log(error);
            return error.response;
        });
};

export const clusterFinalSubmissions = async (topic_problems_id, class_id) => {
    const requestBody = { topic_problems_id, class_id };
    const response = await axios
        .post(
            `${process.env.REACT_APP_LOCAL_API_URL}/clustering/store`,
            requestBody,
            { headers: getAccessToken() }
        )
        .then(res => res.data)
        .catch(err => err.response);

    return response;
}

export const getSubmissionClusters = async (topic_problems_id, problem_id, class_id, search_params) => {
    const urlParams = new URLSearchParams(search_params);
    const requestBody = { topic_problems_id, problem_id, class_id };

    const response = await axios
        .post(
            `${process.env.REACT_APP_LOCAL_API_URL}/clustering/submissions?${urlParams.toString()}`,
            requestBody,
            { headers: getAccessToken() }
        )
        .then(res => res.data)
        .catch(err => err.response);

    return response && response.body;
};
